function getPlatform(ua = navigator.userAgent) {
  var isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isWechat = /(?:MicroMessenger)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isiPad = /(?:iPad)/.test(ua) && isTablet,
    isPc = !isiPhone && !isAndroid && !isSymbian && !isiPad,
    isMobile = !isPc,
    isYixinliApp = /(?:yixinliApp)/.test(ua),
    isMuseApp = /(?:muse)/.test(ua),
    isCeShiApp = /(?:XinLiCeShiApp)/.test(ua),
    isZiXunApp = /(?:yixinliConsultationApp)/.test(ua),
    yixinliAPPVersion = isYixinliApp
      ? ua.match(/YIXINLIAPP;*.*.*/i)[0].split(';')[1]
      : null,
    museAPPVersion = isMuseApp
      ? ua.match(/muse;*.*.*/i)[0].split(';')[1]
      : null,
    isBaiduminiapp = /(?:swan-baiduboxapp)/.test(ua)
  return {
    isWechat,
    isTablet,
    isiPhone,
    isiPad,
    isAndroid,
    isPc,
    isMobile,
    isYixinliApp,
    isMuseApp,
    isCeShiApp,
    isZiXunApp,
    yixinliAPPVersion,
    museAPPVersion,
    isChrome,
    isBaiduminiapp
  }
}

/*
 * 获取当前环境和是否开发状态/环境
 * box/qc环境/本地运行 都被认为是dev状态
 * env 表示当前环境的 boxX/qcX/'' 字符串
 * */
function getRunningEnv() {
  var WEBPACK_DEV = WEBPACK_DEV || false
  let result = {}
  let env = location.host.split('.')[0].match(/(qc|box)\d?/g)
  if (!!env || WEBPACK_DEV) {
    result.isDev = 1
    result.env = env.length > 0 ? env[0] : ''
  } else {
    result.isDev = 0
    result.env = ''
  }
  return result
}

/*
 * 将 str 转换为适配当前环境的域名
 * */
function getEnvHost(str) {
  let { env } = getRunningEnv()
  let result = str
  if (env) {
    result = str.replace(/\./, `-${env}.`)
  }
  console.log(result)
  return result
}

function isIOS9() {
  //获取固件版本
  let getOsv = function() {
    let reg = /OS ((\d+_?){2,3})\s/
    if (
      navigator.userAgent.match(/iPad/i) ||
      navigator.platform.match(/iPad/i) ||
      navigator.userAgent.match(/iP(hone|od)/i) ||
      navigator.platform.match(/iP(hone|od)/i)
    ) {
      let osv = reg.exec(navigator.userAgent)
      if (osv.length > 0) {
        return osv[0]
          .replace('OS', '')
          .replace('os', '')
          .replace(/\s+/g, '')
          .replace(/_/g, '.')
      }
    }
    return ''
  }
  let osv = getOsv()
  let osvArr = osv.split('.')
  console.log('osv', osv, 'osvArr', osvArr)
  if (osvArr && osvArr.length > 0) {
    if (parseInt(osvArr[0]) <= 9) {
      return true
    }
  }
  return false
}

const urlRule = /(node\-website|yiapi|cpapi|m|static|ce|hd|www|medi|meditation){1}(\-(qc\d{1}|box\d{1}))?.(xinli001|onexinli).(com|cc)/ // eslint-disable-line

export { urlRule, getPlatform, getRunningEnv, getEnvHost, isIOS9 }

export default {
  urlRule,
  getPlatform,
  getRunningEnv,
  getEnvHost,
  isIOS9
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/getPlatform.js